<script>
  export let extraStyle = "";
</script>

<div class="dialog-content" style={extraStyle}>
  <slot />
</div>

<style>
  .dialog-content {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
</style>